import {
  EcommercePaymentMethodsAction,
  LOAD_ECOMMERCE_PAYMENT_METHODS,
  LOAD_ECOMMERCE_PAYMENT_METHODS_FAIL,
  LOAD_ECOMMERCE_PAYMENT_METHODS_SUCCESS,
  LoadEcommercePaymentMethods,
  LoadEcommercePaymentMethodsFail,
  LoadEcommercePaymentMethodsSuccess,
} from "../actions";

export interface IEcommercePaymentMethodsEntityState {
  data: any;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommercePaymentMethodsState {
  entities: { [websiteId: number]: IEcommercePaymentMethodsEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommercePaymentMethodsState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommercePaymentMethodsState = initialState, action: EcommercePaymentMethodsAction): IEcommercePaymentMethodsState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PAYMENT_METHODS:
      payload = (<LoadEcommercePaymentMethods>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PAYMENT_METHODS_SUCCESS:
      payload = (<LoadEcommercePaymentMethodsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            data: payload.data,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PAYMENT_METHODS_FAIL:
      payload = (<LoadEcommercePaymentMethodsFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
